import { shiftMarkers } from '../utils/markerShifter';

const indexCardsById = homecards =>
  homecards.filter(Boolean).reduce(
    (acc, homecard) => ({
      ...acc,
      [homecard.id]: homecard
    }),
    {}
  );

export const buildAppData = (
  searchData,
  initialFiltersFromQuery,
  applyShiftMarkers
) => {
  const { paginator, homecards } = searchData.search;
  let { markers } = searchData.search;
  const city = searchData.cities[0];
  const page = paginator.pageNumber;
  const maxPriceInCity = city.maximumPrice;
  const unitPrices = searchData.unitPrices.filter(
    price => price <= maxPriceInCity
  );

  if (applyShiftMarkers) markers = shiftMarkers(markers);

  return {
    maxPriceInCity,
    city,
    initialFiltersFromQuery: { ...initialFiltersFromQuery, page },
    poi: searchData.poi,
    allCities: searchData.allCities,
    internalLinking: {
      countryCode: city.country.countryIsoCode,
      areaSlug: city.id,
      seoLinks: searchData.linking
    },
    isUserLogged: searchData.isLogged,
    initialUnitPrices: unitPrices,
    initialMarkerList: markers,
    initialHomecards: indexCardsById(homecards),
    numberOfMarkers: paginator.count,
    areas: searchData.areas,
    metadata: searchData.metadata
  };
};

export default {
  buildAppData
};
